<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-govdisco">
      <div class="px-3 col-3 p-0">
        <div class="heading-govdisco">{{ $t('result.round') }}</div>
        <div class="text-subhead-govdisco">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-govdisco">{{ $t('result.bet') + `${currency}` }}</div>
        <div class="text-subhead-govdisco">{{ data.count === 0
          ? data.bet
          : data.detail.summary[data.count].bet.amount | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-govdisco">{{ $t('result.winlose') + `${currency}` }}</div>
        <div class="text-subhead-govdisco">{{ winlose | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-govdisco">{{ $t('result.balance') + `${currency}` }}</div>
        <div class="text-subhead-govdisco">{{ balance | currencyFormatter }}</div>
      </div>
    </div>
    <div class="content-result-govdisco pt-3">
      <div class="text-games-govdisco">{{ 'GOVERNMENT DISCO' }}</div>
      <div class="text-subgame-govdisco">{{ $t('govdisco.name') }}</div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>

      <div class="result-wrapper d-flex justify-content-center align-items-center">
        <img src="../../assets/resultGame/govdisco/disco_result.png" />
        <span class="multiplier-text" :class="`-${freespin}`">{{ 'x' + multiplier }}</span>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row container-history">
        <div class="col-1 d-flex align-items-center justify-content-center" style="color: white;">
          <i v-if="isFreespin || isRespin" class="fas fa-caret-left arrow-side-govdisco" @click="delCount()"></i>
        </div>
        <div class="table-govdisco d-flex flex-column justify-content-center">
          <table>
            <tbody class="history-reel">
              <tr v-for="(row, index) in reels[0]" :key="index">
                <td v-for="(col, i) in reels" :key="`${index}${i}`">
                  <div v-if="col[index] > 10">
                    <img class="icon-symbol-govdisco"
                      :src="require(`../../assets/resultGame/govdisco/gold_symbol_${col[index] - 11}.png`)" alt="">
                  </div>
                  <div v-else-if="col[index] <= 10">
                    <img class="icon-symbol-govdisco"
                      :src="require(`../../assets/resultGame/govdisco/symbol_${col[index]}.png`)" alt="">
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!isEndRound" class="fas fa-caret-right arrow-side-govdisco" @click="addCount()"></i>
        </div>
      </div>


      <div class="history-footer">
        <div class="text-center py-4 text-games-govdisco">
          <h1 v-if="isFreespin">{{ $t("result.freespin") }} {{ data.count + 1 }}/{{ data.detail.summary.length }}</h1>
          <h1 v-else>{{ $t("main-game.spin") }} {{ data.count + 1 }}/{{ data.detail.summary.length }}</h1>
        </div>
        <div v-if="winnings.length > 0" class="col-12 justify-content-center d-flex flex-row">
          <hr class="line col-3">
          <div class="text-detail align-items-center d-flex px-3">{{ $t('result.detail') }}</div>
          <hr class="line col-3">
        </div>
        <div v-if="data.detail.featureBuy" class="text-subgame-govdisco">{{ $t("featurebuy.title") }}</div>
        <div v-if="winnings.length" class="col-12 justify-content-center d-flex flex-row">
          <div class="bet-box-govdisco p-2 px-3">
            <div class="bet-warpper item" v-for="(detail, index) in winnings" :key="index">
              <div class="d-flex item justify-content-between px-1 mb-2">
                <div class="bet-wrapper-govdisco item">
                  <div class="d-flex justify-content-start bet-wrapper-govdisco item">
                    <img class="icon-detail-govdisco"
                      :src="require(`../../assets/resultGame/govdisco/symbol_${detail.symbol}.png`)" alt="">
                    <div class="d-flex flex-column align-items-start justify-content-center pl-4">
                      <p class="my-1 green">{{ `${detail.row} ` + $t('result.kind') }}</p>
                      <p v-if="detail.count === 1" class="my-1 green"> {{ `${detail.count}` }} {{ $t('main-game.way') }}
                      </p>
                      <p v-else class="my-1 green"> {{ `${detail.count}` }} {{ $t('main-game.ways') }}</p>
                    </div>
                    <div class="d-flex flex-column justify-content-center px-3">
                      <p class="my-1">{{ currency }} {{ detail.amount | currencyFormatter }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import utils from '../../services/utils'
export default {
  name: 'result-govdisco',
  props: {
    data: Object,
    page: Number,
    isback: Boolean
  },
  data() {
    return {
      headerHeight: null,
      reels: [],
      dateTimeFormatter: function formatter(date) { return utils.dateTimeFormatter(date) },
      tokenData: utils.getTokenData(this.$route.query.t),
      date: '',
      time: '',
      symbolsDetail: [],
      currency: this.data.currency ? this.data.currency : 'THB',
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      isFreespin: false,
      multiplier: 0,
      freespin: '',
      isEndRound: false,
      pages: 0,
    }
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName('header-govdisco')[0].offsetHeight
    },
    mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.multiplier = result.multiplier
      this.isFreespin = (result.state === 'FREESPIN' || result.state === 'FREERESPIN')
      this.isRespin = result.state === 'RESPIN'
      this.symbolsDetail = result.winnings
      this.symbolsbonus = result.bonusWin
      this.freespin = this.isFreespin ? 'free' : ''

      this.reels = result.reels;
      this.isEndRound = result.isEndRound;
      this.winlose = result.win;
      this.bet = result.bet;
      this.balance = result.balance;
      this.winnings = result.winnings;

      if (result.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }

    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
  }
}
</script>

<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #292933
    /* margin: 0; */
}

* {
  margin: 0;
  padding: 0;
}

.container-history {
  transform: scale(1) translate(10px, 20px);
}

.history-footer {
  transform: translate(10px, 80px);
}

.result-wrapper {
  position: relative;
  width: 60%;
  max-width: 265px;
  /* control max size */
  margin: 0 auto;
  /* center horizontally */
}

.result-wrapper img {
  width: 60%;
  height: auto;
  display: block;
  padding-top: 10%;
}

.multiplier-text {
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #7600C4;
  text-shadow: 0px 0px 6px rgba(45, 16, 199, 1);
  /* adjust as needed */
  font-size: 70px;
  /* adjust size */
  font-weight: bold;
  pointer-events: none;
  /* optional */
}

.multiplier-text.-free {
  color: #F4CF0C;
  text-shadow: 0px 0px 6px rgba(245, 0, 3, 1);
}


.history-reel {
  transform: scale(0.9) translate(-6px, 10px);
}

.multiplier-history-img.-center {
  width: 100%;
}

.symbol-gold {
  display: inline;
  position: absolute;
}

.container-multiplier {
  /* transform: scale(1.1) translate(10px, 58px); */
  position: relative;
  z-index: 7;
}

.gold-framed {
  display: inline;
  position: unset;
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.fg-image {
  width: 570px;
}

.multiplier-wrapper {
  top: -95px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
}

.multiplier-image {
  width: 90%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-govdisco {
  width: 100px;
  height: 100px;
  padding: 4px;
}

.icon-bonus-govdisco {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-govdisco {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-govdisco {
  background: #0C161F;
  border-radius: 10px;
  min-height: 200px;
  max-height: 400px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 400px;
}

.bonus-box-govdisco {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-govdisco .item {
  color: #fff;
  background: #06112d;
  line-height: 1;
  border-radius: 10px;
  border: 1.5px solid #cac095;
}

.bet-box-govdisco .bet-wrapper-govdisco:not(:first-child) .item {
  margin-top: 10px;
}

.bet-wrapper-govdisco,
.result-wrapper {
  font-size: 35px;
}

.header-govdisco {
  background: #E9009C;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-govdisco>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-govdisco {
  color: #000000;
  text-align: center;
}

.content-result-govdisco {
  background: #7600C4;
  height: 254vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.content-multiplier-govdisco {
  height: 100%;
  width: 100%;
}

.title>.heading-govdisco {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-govdisco {
  color: #ffffff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-govdisco {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-subgame-govdisco {
  font-size: 20px;
  color: #FFD500;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #FFF5BF;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #c7b873;
  text-align: center;
}

.icon-symbol-govdisco {
  width: 100%;
  /* padding: 5%; */
}

.bet-box-govdisco {
  min-width: 600px;
  max-width: auto;
}

.table-govdisco {
  background: url('~@/assets/resultGame/govdisco/slotmachine.png') no-repeat;
  z-index: 5;
  background-size: 772px 733px;
  /* set Bg Table HERE */
  width: 772px;
  height: 733px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
}

@media screen and (max-width: 1030px) {
  .table-govdisco {
    background-size: 500px 428px;
    width: 500px;
    height: 441px;
  }

  .container-multiplier {
    /* transform: scale(0.8) translate(10px, 64px); */
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }


  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-govdisco {
    min-width: 580px;
    max-width: auto;
    /* height: 280px; */
  }

  .bet-wrapper-govdisco,
  .result-wrapper {
    font-size: 35px;
  }

  .history-footer {
    transform: translate(10px, 60px);
  }
}

@media screen and (min-width: 1060px) {

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .container-multiplier {
    /* transform: scale(0.9) translate(10px, 42px); */
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 570px;
    margin-left: -34px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(1);
    margin-left: 21px;
  }

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-govdisco,
  .result-wrapper {
    font-size: 33px;
  }

}

.line {
  background-color: #c7b873;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #10b24b;
}

@media screen and (max-width: 768px) {
  .heading-govdisco {
    font-size: 18px;
  }

  .table-govdisco {
    background-size: 625px 570px;
    width: 624px;
    height: 570px;
    margin-bottom: 1%;
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .front-table-govdisco {
    background: url('~@/assets/resultGame/govdisco/slotmachine.png') no-repeat;
    background-size: 470px 400px;
    width: 470px;
    height: 300;
    margin-bottom: 1%;
    /* padding-bottom: 35px; */
  }

  .text-subhead-govdisco {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-govdisco {
    min-width: 530px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #c7b873;
    text-align: center;
  }

  .history-reel {
    transform: scale(0.9) translate(0px, 11px);
  }
}

@media screen and (max-width: 500px) {
  .table-govdisco {
    background-size: 416px 383px;
    width: 416px;
    height: 383px;
  }
}

@media screen and (max-width: 750px) {
  .table-govdisco {
    background-size: 416px 383px;
    width: 416px;
    height: 383px;
  }
}

@media screen and (max-width: 480px) {

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-govdisco>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-govdisco {
    font-size: 12px;
  }

  .table-govdisco {
    background-size: 343px 321px;
    width: 347px;
    height: 328px;
    /* padding-top: 2.0rem; */
  }

  .text-subhead-govdisco {
    font-size: 14px;
  }

  .bet-box-govdisco {
    min-width: 320px;
    max-width: auto;
    /* height: 200px; */
  }

  .bonus-box-govdisco {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-govdisco,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-govdisco {
    width: 45px;
    height: 50px;
  }

  .icon-bonus-govdisco {
    width: 60px;
    height: 60px;
  }

  .history-reel {
    transform: scale(0.9) translate(0px, 11px);
  }

  .container-multiplier {
    /* transform: scale(0.6) translate(10px, -90px); */
  }

  .container-history {
    transform: scale(1) translate(10px, 0px);
  }

  .history-footer {
    transform: translate(10px, 0px);
  }

  .multiplier-text {
    font-size: 50px;
  }

  .multiplier-text.-free {
    font-size: 50px;
  }

}
</style>